import { supabase } from '@/lib/supabase';

export const getUserOrgs = async () => {
  const { data, error } = await supabase.rpc('get_user_orgs');
  if (error) {
    throw error;
  }
  return data;
};
